import styled from 'styled-components'

import { colors } from 'themes'

export const Container = styled.section`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  backdrop-filter: blur(8px);
  background: ${colors.popup.background};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 22px;
  padding-top: max(22px, calc(var(--native-safe-area-top, env(safe-area-inset-top, 0px)) + 12px));
  padding-bottom: max(22px, calc(env(safe-area-inset-bottom, 0px) + 12px));
  opacity: 0;
  pointer-events: none;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: manipulation;
  &.opened {
    opacity: 1;
    pointer-events: auto;
  }
  transition: 200ms ease-in-out;

  z-index: 99999;
  > * {
    transform: scale(0.4);
    transition: 200ms ease-in-out;

    box-sizing: border-box;
  }

  &.opened {
    > * {
      transform: scale(1);
    }
  }
`

export const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  touch-action: none;
`
